// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "frontend-assets/css/" + chunkId + "." + {"89":"b7caefb8","175":"387bf6d5","238":"58125d5b","250":"31364a06","318":"14ab55ec","878":"058b80d7","932":"faad8f62"}[chunkId] + ".css";
};